<template>
  <v-container fluid class="pa-0" style="margin-top: 2vh">
    <v-data-table
      :headers="headers"
      :items="organizationList"
      :items-per-page="10"
      class="elevation-1"
      @click:row="onOrganizationClick"
      :search="search"
    >
      <template v-slot:top>
        <v-row class="upper-elements">
          <v-col class="d-flex align-center">
            <v-dialog persistent v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on }">
                <v-btn class="ml-4" small v-on="on">Create {{ context }}</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.name"
                          label="Name"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-checkbox
                          v-model="editedItem.hideUnitStatus"
                          label="Hide Unit Statuses"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.address1"
                          label="Address 1"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.address2"
                          label="Address 2"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.address3"
                          label="Address 2"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.city"
                          label="City"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.state"
                          label="State"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.postalCode"
                          label="Postal code"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.country"
                          label="Country"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.phone"
                          label="Phone"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.domain"
                          label="Domain"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="11">
                        <v-text-field
                          v-model="editedItem.logo"
                          label="Logo url"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="2" md="11">
                        <v-textarea
                          v-model="editedItem.stylesheet"
                          label="Stylesheet"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save()"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="2" sm="2" md="2">
            <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              outlined=""
              label="Search"
              hide-details
              class="mr-4"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <tr>
          {{
            item.name
          }}
        </tr>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon size="18" class="mr-3" @click="editItem(item, $event)"
          >edit</v-icon
        >
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  name: 'OrganizationList',
  props: {
    context: {
      type: String,
      required: false,
      default: 'organization'
    }
  },
  components: {},
  data: function() {
    return {
      editedIndex: -1,
      organizationList: this.$store.state.OrganizationStore.organizations,
      editedItem: {
        id: 0,
        organizationId: 0,
        name: '',
        address1: '',
        address2: '',
        address3: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
        phone: '',
        domain: '',
        logo: '',
        stylesheet: '',
        hideUnitStatus: false,
      },
      defaultItem: {
        id: 0,
        organizationId: 0,
        name: '',
        address1: '',
        address2: '',
        address3: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
        phone: '',
        domain: '',
        logo: '',
        stylesheet: '',
        hideUnitStatus: false,
      },
      dialog: false,
      search: '',
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.context.toUpperCase(),
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Actions', value: 'action', sortable: false, align: 'right' }
      ]
    },
    formTitle() {
      return this.editedIndex === -1
        ? 'New ' + this.context
        : 'Edit ' + this.context
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    '$store.state.OrganizationStore.organizations'() {
      this.organizationList = this.$store.state.OrganizationStore.organizations
    }
  },
  created: function() {
    this.$store.dispatch('OrganizationStore/fetchOrganizations')
  },
  methods: {
    onOrganizationClick(organization) {
      const path = `/organizations/${organization.id}`
      if (this.$route.path !== path) this.$router.push(path)
      this.$store.dispatch('ProjectStore/fetchProjects')
    },
    editItem(item, e) {
      e.stopPropagation()
      e.preventDefault()
      this.editedIndex = this.organizationList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem(item, e) {
      e.stopPropagation()
      this.$store.dispatch('DialogStore/open', {
        title: 'Delete ' + this.context,
        header: false,
        subtitle: 'Are you sure?',
        okText: 'Ok',
        ok: () => {
          this.deleteItemAction(item)
        },
        cancelText: 'Cancel'
      })
    },
    deleteItemAction(item) {
      const index = this.organizationList.indexOf(item)
      this.$store
        .dispatch('OrganizationStore/deleteOrganization', item.id)
        .then(res => {
          this.organizationList.splice(index, 1)
        })
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save: async function() {
      if (this.editedIndex > -1) {
        this.$store.dispatch(
          'OrganizationStore/updateOrganization',
          this.editedItem
        )
      } else {
        await this.$store.dispatch(
          'OrganizationStore/addOrganization',
          this.editedItem
        )
      }
      await this.$store.dispatch('OrganizationStore/fetchOrganizations')
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.upper-elements {
  margin-bottom: 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.v-data-footer {
  margin-bottom: 16px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}
</style>
